var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('link-button',{class:[ _vm.type ? 'link-btn--' + _vm.type : '' ],attrs:{"href":_vm.href,"icon":_vm.icon,"rel":"nofollow noopener noreferrer","blank":""}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }